import { useAuth } from '@trimble-oss/trimble-id-react';
import { i18nException } from '@/models';
import I18N_RESOURCE from '@/i18n/template';

const useCredentials = () => {
  const { user, getAccessTokenSilently } = useAuth();

  const getAccessTokenSilentlyErrorHandling = async () => {
    try {
      return await getAccessTokenSilently();
    } catch (error) {
      throw new i18nException(
        'EXCEPTIONS.TOKEN_EXPIRED',
        I18N_RESOURCE.EXCEPTIONS.TOKEN_EXPIRED,
        'error',
        'InvalidIssuerException'
      );
    }
  };

  return {
    user,
    getAccessTokenSilently: getAccessTokenSilentlyErrorHandling,
  };
};

export default useCredentials;
